require('./dist/angular-filter.js');
module.exports = 'angular.filter';



//////////////////
// WEBPACK FOOTER
// ./~/angular-filter/index.js
// module id = 566
// module chunks = 1